// アプリのエントリーポイント。
// App を #root にマウントする。React 19 / StrictMode なし（reference 踏襲）。
import ReactDOM from 'react-dom/client'
import App from './App.jsx'

ReactDOM.createRoot(document.getElementById('root')).render(<App />)
